import {changeEvent, clickEvent, fireChangeEvent, keyupEvent} from "../../../webpack/modules/events";
import {updatePriceElements} from "../../../webpack/modules-optimized/product-page";

let timeoutKeyupQuantity = null;
keyupEvent('#product-page .quantity-selector input[name="quantity"]', false, function(input) {
    let container = input.closest('.product-scope');

    clearTimeout(timeoutKeyupQuantity);
    timeoutKeyupQuantity = setTimeout(function() {
        if (parseInt(input.value) < 1) input.value = 1;
        if (input.dataset.calculatePrice === 'true') updatePriceElements(container);
        updateChangeQuantityButtons(input);
    }, 300);
});

let timeoutChangeQuantity = null;
clickEvent('#product-page .quantity-selector .change-quantity', false, function(button) {
    let container = button.closest('.product-scope');
    let quantitySelector = button.closest('.quantity-selector');
    let input = quantitySelector.querySelector('input[name="quantity"]');
    let value = parseInt(input.value);

    if (button.dataset.action === 'add') input.value = value + 1;
    else if (button.dataset.action === 'remove') input.value = value > 1 ? value - 1 : 1;
    updateChangeQuantityButtons(input);

    clearTimeout(timeoutChangeQuantity);
    timeoutChangeQuantity = setTimeout(function() {
        if (input.dataset.calculatePrice === 'true') updatePriceElements(container);
    }, 300);
});

function updateChangeQuantityButtons(input)
{
    let quantitySelector = input.closest('.quantity-selector');
    let removeButton = quantitySelector.querySelector('.change-quantity[data-action="remove"]');

    removeButton.disabled = input.value <= 1;
}

